import request from '@/utils/request'

/**
 * 获取经销商报表
 * @param {*} data
 */
function getSubReport(data) {
  return request({
    url: '/report/subCompany/list',
    method: 'post',
    data
  })
}
/**
 * 导出经销商报表
 * @param {*} data
 */
function exportSub(data) {
  return request({
    url: '/report/subCompany/export',
    method: 'post',
    responseType: 'arraybuffer',
    data
  })
}
export {
    getSubReport,
    exportSub
  }
  